import axios from 'axios'
const api = "configurar"

const cedisStockAgotado = {
    getCedis: () => axios.get(`${api}/get-cedis-stock-agotado`),
    setCedisStockAgotado: (idCedis,params) => axios.put(`${api}/${idCedis}/set-cedis-stock-agotado`,params),
}
export default cedisStockAgotado